<template>
    <StandardLayout header="Steueransicht">
        <template v-slot:main>
            <div class="row">
                <div class="col-4 form-group">
                    <label for="monthInput">Monat</label>
                    <select id="monthInput" class="form-control" v-model.number="month">
                        <option :value="1">Jan</option>
                        <option :value="2">Feb</option>
                        <option :value="3">Mär</option>
                        <option :value="4">Apr</option>
                        <option :value="5">Mai</option>
                        <option :value="6">Jun</option>
                        <option :value="7">Jul</option>
                        <option :value="8">Aug</option>
                        <option :value="9">Sep</option>
                        <option :value="10">Okt</option>
                        <option :value="11">Nov</option>
                        <option :value="12">Dez</option>
                    </select>
                </div>
                <div class="col-3 form-group">
                    <label for="yearInput">Jahr</label>
                    <input id="yearInput" class="form-control" v-model="year"/>
                </div>
                <div class="col-2 ml-1">
                    <button class="btn btn-primary position-absolute" style="bottom: 16px;" @click="loadTaxData">OK
                    </button>
                </div>
            </div>
            <div class="card">
                <div class="card-header">
                    <div class="d-flex justify-content-between">
                        <div>Ergebnisse</div>
                        <div>
                            <button class="btn btn-sm btn-primary" @click="copyToClipboard">In die Zwischenablage
                            </button>
                            <button class="d-none btn btn-sm btn-primary" @click="downloadTsv">TSV für Excel herunterladen
                            </button>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row mt-3" v-if="resultList && resultList.length > 0">
                        <table class="table" id="taxTable">
                            <thead>
                            <tr>
                                <th>#</th>
                                <th>bezahlt</th>
                                <th>Kunde</th>
                                <th>Brutto</th>
                                <th>Netto</th>
                                <th>USt.</th>
                            </tr>
                            </thead>
                            <tbody id="taxTableBody">
                            <tr v-for="result in resultList" :key="result.id">
                                <td>{{ result.number }}</td>
                                <td>{{ result.paymentTime | shortDateTime }}</td>
                                <td>{{ result.customerLastName }}</td>
                                <td>{{ result.amount | num }}</td>
                                <td>{{ result.netAmount | num }}</td>
                                <td>{{ result.vat | num }}</td>
                            </tr>
                            <tr class="font-weight-bold">
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>&nbsp;</td>
                                <td>
                                    {{ totalAmount | num }}
                                </td>
                                <td>
                                    {{ totalNetAmount | num }}
                                </td>
                                <td>
                                    {{ totalVat | num }}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else>
                        Wähle zunächst Monat und Jahr aus.
                    </div>
                </div>
            </div>
        </template>
    </StandardLayout>
</template>

<script>
import StandardLayout from "@/layouts/StandardLayout.vue";

export default {
    components: {StandardLayout},
    data() {
        return {
            resultList: [],
            month: new Date().getMonth(),
            year: new Date().getFullYear()
        }
    },
    computed: {
        totalAmount() {
            return this.resultList.reduce((sum, t) => sum += t.amount, 0)
        },
        totalNetAmount() {
            return this.resultList.reduce((sum, t) => sum += t.netAmount, 0)
        },
        totalVat() {
            return this.resultList.reduce((sum, t) => sum += t.vat, 0)
        },
    },
    methods: {
        loadTaxData() {
            this.$api.get('/taxes', {
                params: {
                    month: this.month,
                    year: this.year
                }
            }).then(res => this.resultList = res.data)
                .catch(err => this.handleError(err))
        },
        copyToClipboard() {
            let taxTableBody = document.getElementById("taxTable");
            navigator.clipboard.writeText(taxTableBody.innerText.trim());
            this.showInfo("Daten in die Zwischenablage kopiert.")
        },
        downloadTsv() {
            return this.$api.get("/taxes/tsv", {
                params: {
                    month: this.month,
                    year: this.year
                }
            }).then(response => {
                console.log(response.data)
                const blob = new Blob([response.data], {
                    type: 'text/plain;charset=utf-8'
                });
                const url = window.URL.createObjectURL(blob);
                const a = document.createElement('a');
                a.href = url;
                a.download = 'SPABoot Rechnungen ' + this.year + ' ' + this.month + '.tsv';
                a.click();
            }).catch(error => this.handleError(error))
        }
    },
    mounted() {
        this.loadTaxData()
    }
}
</script>
